<div
	*ngIf="articleGroup"
	class="wrapper"
	[class.green_light]="orderStatus == orderStatusEnum.DONE"
	[class.green]="orderStatus == orderStatusEnum.READY"
	[class.orange]="orderStatus == orderStatusEnum.IN_PREPARATION"
>
	<!-- [class.red]="hasInactiveArticles()" -->
	<div class="article_name_block">
		<!-- [class.red]="hasInactiveArticles(articleGroup.article)" -->
		<div class="quantity">{{ articleGroup.quantity }}</div>
		<p class="name main" (click)="showDetails($event, articleGroup.article)">
			{{ articleGroup.article.name.de }}
		</p>
	</div>

	<div *ngIf="articleGroup.note" class="note_block">
		<p>Note:</p>
		<p>
			{{ articleGroup.note }}
		</p>
	</div>

	@for (group of articleGroup.groups; track group?._id) {
	<div class="article_name_block">
		<!-- [class.red]="hasInactiveArticles(group.article)" -->
		<div class="quantity">{{ group.quantity }}</div>

		<p class="name" (click)="showDetails($event, group.article)">
			{{ group.article.name.de }}
		</p>
	</div>
	}
</div>

<div *ngIf="detailsVisible" (click)="hideDetails()" class="backdrop">
	<div
		class="details_block"
		[ngStyle]="{
			top: detailsPosition.y + 'px',
			left: detailsPosition.x + 'px',
			transform: 'translate(0%, -100%)'
		}"
	>
		<p>{{ 'order_item_articlegroup_draw.inactive_info' | translate }}</p>
	</div>
</div>
